import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {AuthenticatedUser} from '../models';
import {StorageService} from '../services';

/**
 * Checks whether the user can access the club-overview list.
 */
@UntilDestroy()
@Injectable()
export class ClubListGuard implements OnDestroy {
  private authenticatedUser?: AuthenticatedUser;

  constructor(
    private storage: StorageService,
    private router: Router
  ) {
    this.storage.castAuthenticatedUser.pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => user !== null ? this.authenticatedUser = user : null);
  }

  public ngOnDestroy(): void {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const clubs = this.authenticatedUser.clubs;
    if (this.authenticatedUser !== null) {
      const user = this.authenticatedUser;
      // check if user has the right permission
      if (user.isAdmin || user.isCallCenterAgent || user.isCountryManager) {
        // permission is there so we return true
        return true;
      }
    }
    if (clubs.length === 1) {
      this.router.navigate([`/club/${clubs[0].id}`]);
      return false;
    } else {
      this.router.navigate(['/logout']);
      return false;
    }
  }
}
